const APIURL = process.env.API_URL || '/api/';
export default { APIURL };
export { APIURL };